import React from 'react'
import {
  createBookedEventLocalParticipantIdentity,
  createBookedEventPeerParticipantHint,
} from '../../session'
import { SESSION_INTERFACE_IDS } from '../../domain'
import SharedRtcVideoSurface from './SharedRtcVideoSurface'

function normalizeLocalParticipantIdentity(bookedEventInfo, userRole, auxiliaryData) {
  if (auxiliaryData?.localParticipantIdentity) {
    return auxiliaryData.localParticipantIdentity
  }

  if (bookedEventInfo?.localParticipantIdentity) {
    return bookedEventInfo.localParticipantIdentity
  }

  return createBookedEventLocalParticipantIdentity(bookedEventInfo, userRole)
}

export default function StandardLiveRtcVideoSurface({
  sessionRoutingDecision,
  agoraRtcProps,
  agoraRtmProps,
  handleLeaveRoom,
  bookedEventInfo,
  auxiliaryData,
  userRole,
  peerChatId,
  peerChatName,
  peerChatImage,
  onUserJoin,
  onUserLeave,
  isFullHeight,
  onCameraClose,
  onCameraOpen,
  onAudioClose,
  onAudioOpen,
  callContainerStyles = {},
  agoraKitStyleProps = {},
  playAudioOnUserJoin = true,
  playAudioOnUserLeave = true,
  providerFallback = null,
}) {
  const localParticipantIdentity = React.useMemo(
    () => normalizeLocalParticipantIdentity(bookedEventInfo, userRole, auxiliaryData),
    [auxiliaryData, bookedEventInfo, userRole],
  )
  const peerParticipantHint = React.useMemo(
    () =>
      createBookedEventPeerParticipantHint(bookedEventInfo, userRole, {
        peerUserId: peerChatId,
        peerDisplayName: peerChatName,
        peerProfilePicId: peerChatImage,
      }),
    [bookedEventInfo, peerChatId, peerChatImage, peerChatName, userRole],
  )
  const sessionInterfaceId =
    auxiliaryData?.sessionInterfaceId ||
    bookedEventInfo?.sessionInterfaceId ||
    SESSION_INTERFACE_IDS.standardLive

  return (
    <SharedRtcVideoSurface
      sessionRoutingDecision={sessionRoutingDecision}
      agoraRtcProps={agoraRtcProps}
      agoraRtmProps={agoraRtmProps}
      handleLeaveRoom={handleLeaveRoom}
      localParticipantIdentity={localParticipantIdentity}
      peerParticipantHint={peerParticipantHint}
      sessionInterfaceId={sessionInterfaceId}
      onUserJoin={onUserJoin}
      onUserLeave={onUserLeave}
      isFullHeight={isFullHeight}
      onCameraClose={onCameraClose}
      onCameraOpen={onCameraOpen}
      onAudioClose={onAudioClose}
      onAudioOpen={onAudioOpen}
      callContainerStyles={callContainerStyles}
      agoraKitStyleProps={agoraKitStyleProps}
      playAudioOnUserJoin={playAudioOnUserJoin}
      playAudioOnUserLeave={playAudioOnUserLeave}
      providerFallback={providerFallback}
    />
  )
}

StandardLiveRtcVideoSurface.displayName = 'StandardLiveRtcVideoSurface'
